import styled, { css } from 'styled-components';
import { getBorderRadius } from '../_styles/borderRadius';
import { colors } from '../_styles/colors';
import { focusable } from '../_styles/mixins';
function getLinkColors(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant;
  switch (variant) {
    case 'gray':
      return css(["color:", ";&:hover{color:", ";}"], colors.gray30, colors.orange50);
    case 'white':
      return css(["color:", ";&:hover{color:", ";}"], colors.white, colors.gray85);
    case 'default':
    default:
      return css(["color:", ";&:hover{color:", ";}"], colors.blue45, colors.blue30);
  }
}
export var StyledLink = /*#__PURE__*/styled.a.withConfig({
  displayName: "StyledLink",
  componentId: "core-12_15_0__sc-jfowrl-0"
})(["text-decoration:underline;&:hover{cursor:pointer;text-decoration:underline;}", " &.focus,&:focus{", ";}", ""], focusable, getBorderRadius('md'), getLinkColors);
//# sourceMappingURL=Link.styles.js.map